import type { LineItemBuilder } from "../../../../../utils/cartUpdating/LineItemUpdate";
import { convertProductToImpressionCart, trackCartChange } from "../../../../Analytics/ga/ga";
import type { RootState } from "../../../../../redux/store";
import { groupByFn } from "../../../../../utils/reducers";
import { selectProductDescriptor } from "../../../../../redux/products/productsSelectors";
import { getPricePerPiece } from "../../../../ProductDescriptor/v1/productDescriptorUtils";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";

export function getDesciptorsForLineItems(state: RootState, productCode: string, lineItems: LineItemBuilder[]) {
  const priceReferences = Object.keys(groupByFn(lineItems, (item) => item.get("priceReference")));
  return priceReferences.reduce((map, priceReference) => {
    map[priceReference] = selectProductDescriptor(state, {
      productCode,
      priceReference,
    });
    return map;
  }, {} as Dict<ProductDescriptor>);
}

export function trackCartUpdate(editedLineItem: LineItemBuilder, productDescriptor: ProductDescriptor) {
  if (!editedLineItem.hasUpdatesForSending()) {
    return;
  }
  const { base, availability } = productDescriptor;

  const oldLineItem = editedLineItem.getOriginal();
  const oldImpression = convertProductToImpressionCart(base, oldLineItem, availability, getPricePerPiece(oldLineItem));

  const newLineItem = editedLineItem.buildForSending()!;
  const newImpression = convertProductToImpressionCart(base, newLineItem, availability, getPricePerPiece(newLineItem));
  trackCartChange(oldImpression, newImpression);
}
